<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Magazzino Ingresso</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="showFilter = !showFilter"
            >
              <v-icon color="purple"> mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.replace('/home')"
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>
      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-row v-if="showFilter" class="ma-1">
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-autocomplete
            dense
            outlined
            label="codice articolo"
            v-model="filtro_articolo"
            :items="articoli"
          >
          </v-autocomplete>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-autocomplete
            dense
            outlined
            label="descrizione articolo"
            v-model="filtro_descrizone"
            :items="descrizioni"
          >
          </v-autocomplete>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-autocomplete
            dense
            outlined
            label="lotto"
            v-model="filtro_lotto"
            :items="lotti"
          >
          </v-autocomplete>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-autocomplete
            dense
            outlined
            label="DDT"
            v-model="filtro_ddt"
            :items="ddt"
          >
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-card-text>
        <v-row v-if="qntErr">
          <v-col class="error--text">
            Errore: La quantita specificata deve essere uguale o minore della
            quantita disponibile e maggiore di 0
          </v-col>
        </v-row>
        <v-row v-if="pesoErr">
          <v-col class="error--text">
            Errore: Raggiunto peso massimo consentito
          </v-col>
        </v-row>

        <v-data-table
          :items="tabella.filter((e) => e.quantita > 0
            && (filtro_articolo == 'Tutti' || e.cod_articolo == filtro_articolo)
            && (filtro_ddt == 'Tutti' || e.num_documento == filtro_ddt)
            && (filtro_descrizone == 'Tutti' || e.des_articolo == filtro_descrizone)
            && (filtro_lotto == 'Tutti' || e.cod_lotto == filtro_lotto))"
          :headers="headers"
        >
          <template v-slot:[`item.azioni`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="item.id_ubicazione_dest == -1 || qntErr || pesoErr"
                  v-on="on"
                  small
                  elevation="1"
                  @click="setMovimento(item)"
                >
                  <v-icon color="success">mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Conferma Ubicazione</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.ubicazione`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  class="mr-1"
                  @click="modificaUbicazione(item)"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Modifica Ubicazione</span>
            </v-tooltip>
            {{ item.path }}
          </template>
          <template v-slot:[`item.qnt_ubi`]="{ item }">
            <v-col cols="6" dense>
              <v-text-field
                :disabled="item.path == 'Nessuno'"
                dense
                type="number"
                v-model="item.qnt_ubi"
                @change="changeQnt(item)"
                @keyup="changeQnt(item)"
              >
              </v-text-field>
            </v-col>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog persistent v-model="ubicazioneDialog" width="400">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"
            >Selezione Ubicazione</v-toolbar-title
          >

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="ubicazioneDialog = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>

        <v-col>
          <v-select
            :items="magazzini"
            @change="getStruttura"
            item-text="des_magazzino"
            v-model="selMagazzino"
            return-object
            label="magazzino"
            dense
            outlined
          >
          </v-select>
          <v-card flat max-height="60vh" class="overflow-y-auto">
            <v-treeview :items="ubicazioneTree" return-object item-key="name">
              <template v-slot:append="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      v-if="item.children == null && !item.disabled"
                      class="mr-2"
                      small
                      elevation="1"
                      @click="confirmSelectUbicazione(item)"
                    >
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span>Seleziona</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on" v-if="item.disabled">
                      mdi-cancel
                    </v-icon>
                  </template>
                  <span>Articolo Proibito in Questa Posizione</span>
                </v-tooltip>
              </template>
            </v-treeview>
          </v-card>
        </v-col>
      </v-card>
    </v-dialog>

    <v-overlay :value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "MagazzinoIngresso",
  components: {
    SnackbarQV,
  },
  data() {
    return {
      showFilter: false,
      loading: false,
      showOverlay: false,
      ubicazioneDialog: false,
      qntErr: false,
      pesoErr: false,
      selMagazzino: null,
      filtro_lotto: "Tutti",
      filtro_articolo: "Tutti",
      filtro_ddt: "Tutti",
      filtro_descrizone: "Tutti",
      tableKey: 0,
      tempItem: {},
      articoli: [],
      descrizioni: [],
      lotti: [],
      ddt: [],
      magazzini: [],
      ubicazioneTree: [],
      tabella: [],
      headers: [
        {
          text: "Azioni",
          value: "azioni",
        },
        {
          text: "Ubicazione Destinazione",
          value: "ubicazione",
        },
        {
          text: "Quantita da Ubicare",
          value: "qnt_ubi",
        },
        {
          text: "Codice Articolo",
          value: "cod_articolo",
        },
        {
          text: "Descrizione Articolo",
          value: "des_articolo",
        },
        {
          text: "Codice Lotto",
          value: "cod_lotto",
        },
        {
          text: "Riferimento DDT",
          value: "num_documento",
        },
        {
          text: "Quantita",
          value: "quantita",
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    await this.getMagazzinoIngresso();
    this.loading = false;
  },
  methods: {
    async getMagazzinoIngresso() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzinoingresso",
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store.dispatch("api", request).then((res) => {
        if (res.data.response === true) {
          this.lotti = [];
          this.articoli = [];
          this.descrizioni = [];
          this.ddt = [];
          this.tabella = Array.from(res.data.result);
          this.tabella.forEach((e) => {
            e.id_ubicazione_dest = -1;
            e.path = "Nessuno";
            e.qnt_ubi = 0;
            if (!this.ddt.includes(e.num_documento))
              this.ddt.push(e.num_documento);
            if (!this.articoli.includes(e.cod_articolo))
              this.articoli.push(e.cod_articolo);
            if (!this.descrizioni.includes(e.des_articolo))
              this.descrizioni.push(e.des_articolo);
            if (!this.lotti.includes(e.cod_lotto))
              this.lotti.push(e.cod_lotto);
          });
          this.ddt.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
          this.ddt.unshift("Tutti");
          this.articoli.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
          this.articoli.unshift("Tutti");
          this.lotti.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
          this.lotti.unshift("Tutti");
          this.descrizioni.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
          this.descrizioni.unshift("Tutti");
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore: Impossibile caricare dati"
          );
        }
        this.loading = false;
      });
    },
    getStruttura(arg) {
      this.loading = true;
      var request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzinoubicazione",
          token: localStorage.user_token,
          id_utente: localStorage.id,
          id_magazzino: arg.id_magazzino,
        },
      };

      this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200) {
          this.ubicazioneTree = Array.from(res.data.dettaglio0);
          this.fixtree(this.ubicazioneTree, false);
          console.log(this.ubicazioneTree);
          this.$forceUpdate();
          this.loading = false;
        }
      });
    },
    fixtree(arg, disable) {
      try {
        arg.forEach((e) => {
          e.disabled = disable;
          if (
            e.famiglie_proibite != null &&
            (e.famiglie_proibite.includes(this.tempItem.id_famiglia) ||
              e.famiglie_proibite.includes(this.tempItem.id_sotto_famiglia))
          ) {
            e.disabled = true;
          }
          if (
            e.articoli_proibiti != null &&
            e.articoli_proibiti.includes(this.tempItem.id_articolo)
          ) {
            e.disabled = true;
          }

          e.children = null;
          Object.keys(e).forEach((k) => {
            if (k.includes("dettaglio") && !k.includes("_")) {
              e.children = e[k];
            }
          });
          e.name = e.des_dettaglio;
          this.fixtree(e.children, e.disabled);
        });
      } catch (error) {
        console.log(error);
        return;
      }
    },
    modificaUbicazione(item) {
      this.tempItem = item;
      this.loading = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzini",
          token: localStorage.user_token,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.magazzini = Array.from(res.data);
        this.loading = false;
        this.ubicazioneDialog = true;
      });
    },
    async confirmSelectUbicazione(item) {
      this.tempItem.ubicazione_max_peso = item.peso_massimo;
      this.loading = true;
      var ubicazioni = [{ id_ubicazione: item.id_magazzino_ubicazione }];
      var peso = 0;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getubicazionimovimenti",
          ubicazioni: ubicazioni,
          token: localStorage.user_token,
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        res.data.result[item.id_magazzino_ubicazione.toString()].forEach(
          (e) => {
            peso += e.peso_netto * e.quantita;
          }
        );
        this.tempItem.ubicazione_att_peso = peso;
        this.tempItem.articoliPresenti =
          res.data.result[item.id_magazzino_ubicazione.toString()];
        this.key++;
        this.loading = false;
      });
      this.tempItem.path = item.path;
      this.tempItem.id_ubicazione_dest = item.id_magazzino_ubicazione;
      this.tempItem.id_magazzino_dest = item.id_magazzino;
      this.ubicazioneDialog = false;
      console.log(this.listDDT);
    },
    changeQnt(item) {
      console.log(item.peso_netto);
      console.log(item.ubicazione_att_peso);
      console.log(item.ubicazione_max_peso);
      console.log(item.quantita * item.peso_netto);
      if (
        item.ubicazione_max_peso != null &&
        item.qnt_ubi * item.peso_netto + item.ubicazione_att_peso >
          item.ubicazione_max_peso
      ) {
        this.pesoErr = true;
      } else {
        this.pesoErr = false;
      }
      if (item.qnt_ubi > item.quantita || item.qnt_ubi < 1) {
        this.qntErr = true;
      } else {
        this.qntErr = false;
      }
      this.tableKey++;
    },
    async setMovimento(item) {
      this.showOverlay = true;
      var movimenti = [];
      movimenti.push({
        id_ubicazione: item.id_ubicazione_dest,
        quantita: item.qnt_ubi,
        validita: 1,
        id_articolo: item.id_articolo,
        cod_articolo: item.cod_articolo,
        des_articolo: item.des_articolo,
        id_documento_dettaglio: item.id_documento_dettaglio,
        id_magazzino: item.id_magazzino_dest,
        cod_lotto: item.cod_lotto,
      });
      movimenti.push({
        id_ubicazione: item.id_ubicazione,
        quantita: item.qnt_ubi * -1,
        validita: 1,
        id_articolo: item.id_articolo,
        cod_articolo: item.cod_articolo,
        des_articolo: item.des_articolo,
        id_documento_dettaglio: item.id_documento_dettaglio,
        id_magazzino: item.id_magazzino,
        cod_lotto: item.cod_lotto,
      });
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setmovimentimagazzino",
          token: localStorage.user_token,
          movimento: movimenti,
        },
      };
      await this.$store
        .dispatch("api", request)
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Movimento Salvato");
          } else {
            this.$refs.SnackbarQV.print("orange", "Movimento non Salvato");
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print("orange", "Movimento non Salvato");
          }
        });
      await this.getMagazzinoIngresso();
      this.showOverlay = false;
    },
  },
};
</script>